import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
    height: '100%',
    width: '100%',
    '& .msg-box': {
      '&-icon': {
        marginBottom: theme.spacing(1),
        color: theme.palette.text.secondary,
      },
      '&-text': {
        color: theme.palette.text.secondary,
      },
      '&-button': {
        marginTop: theme.spacing(3),
      },
    },
    '&.warning': {
      '& .msg-box': {
        '&-icon': {
          color: theme.palette.custom.feedback.warning,
        },
      },
    },
    '&.error': {
      '& .msg-box': {
        '&-icon': {
          color: theme.palette.custom.feedback.negative,
        },
      },
    },
    '&.success': {
      '& .msg-box': {
        '&-icon': {
          color: theme.palette.custom.feedback.positive,
        },
      },
    },
    '&.info': {
      '& .msg-box': {
        '&-text': {
          color: theme.palette.text.hint,
        },
      },
    },
  },
}));

export default styles;
